import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import * as pujaServices from "../../services/puja.services";
import CustomPagination from "../../common/custompagination";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import { Modal, Button, Form } from "react-bootstrap";
import { formateDateWithMonth } from "../../../../utils/commonfunction";

const ReschedulePujaList = () => {
    const { t } = useTranslation();

    const [list, setList] = useState([]);
    const [datalength, setDataLength] = useState(0);
    const [itemperpage] = useState(10);
    const [page, setPage] = useState(1);
    const [sorting, setSorting] = useState({});
    const [loader, setLoader] = useState(true);
    const [globalsearch, setGlobalSearch] = useState("");
    // Fixed search to only fetch "rescheduled" status
    const [search, setSearch] = useState({ booking_status: "rescheduled" });
    const [resetdate, setResetDate] = useState(false);

    // Reschedule Modal State
    const [showModal, setShowModal] = useState(false);
    const [selectedBookingId, setSelectedBookingId] = useState(null);
    const [rescheduleDate, setRescheduleDate] = useState("");
    const [rescheduleTime, setRescheduleTime] = useState("");
    const [actionLoader, setActionLoader] = useState(false);

    const breadcrumbs = [
        { title: "Dashboard", url: "/admin/dashboard" },
        { title: "Reschedule Puja", url: "" },
    ];

    // Fetch bookings
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoader(true);
            const formData = new FormData();
            formData.append("page", page);
            formData.append("per_page", itemperpage);
            formData.append("sort", JSON.stringify(sorting));
            formData.append("search", JSON.stringify(search));
            formData.append("global_search", globalsearch);

            pujaServices
                .BookingList(formData)
                .then((res) => {
                    setList(res.data.list || []);
                    setDataLength(res.data.total_records || 0);
                    setPage(res.data.page || 1);
                    setLoader(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoader(false);
                });
        }, 300);

        return () => clearTimeout(timer);
    }, [page, sorting, search, globalsearch, resetdate]);

    const resetFilter = () => {
        setGlobalSearch("");
        setSearch({ booking_status: "rescheduled" });
        setResetDate(!resetdate);
    };

    const openRescheduleModal = (booking) => {
        setSelectedBookingId(booking.id);
        setRescheduleDate(booking.booking_date || "");
        setRescheduleTime(booking.booking_time || "");
        setShowModal(true);
    };

    const handleReschedule = () => {
        if (!rescheduleDate || !rescheduleTime) {
            Swal.fire("Warning", "Please select both date and time", "warning");
            return;
        }

        setActionLoader(true);
        pujaServices
            .RescheduleBooking({
                booking_id: selectedBookingId,
                date: rescheduleDate,
                time: rescheduleTime,
            })
            .then((res) => {
                setActionLoader(false);
                if (res.success || res.status === 200 || res.data?.success) {
                    Swal.fire("Success", "Booking rescheduled successfully", "success");
                    setShowModal(false);
                    setResetDate((p) => !p);
                } else {
                    throw new Error(res.message || res.data?.message || "Reschedule failed");
                }
            })
            .catch((err) => {
                setActionLoader(false);
                Swal.fire("Error", err.message || "Failed to reschedule", "error");
            });
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label mb-0">Reschedule Puja</h6>
                            <div className="d-flex align-items-center gap-2">
                                <div className="form-group mb-0">
                                    <input
                                        type="search"
                                        className="form-control"
                                        placeholder="Search bookings..."
                                        value={globalsearch}
                                        onChange={(e) => setGlobalSearch(e.target.value)}
                                    />
                                </div>
                                <button
                                    className="btn btn-outline-warning"
                                    onClick={resetFilter}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>User</th>
                                        <th>Puja Name</th>
                                        <th>Old Date & Time</th>
                                        <th>Astrologer</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Payment</th>
                                        <th className="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : list.length > 0 ? (
                                        list.map((row, i) => (
                                            <tr key={row.id}>
                                                <td>{(page - 1) * itemperpage + i + 1}</td>
                                                <td>{row.user?.name || "N/A"}</td>
                                                <td>{row.puja?.title || "N/A"}</td>
                                                <td>
                                                    {row.booking_date ? (
                                                        <>
                                                            {formateDateWithMonth(row.booking_date)}
                                                            <br />
                                                            {row.booking_time || "-"}
                                                        </>
                                                    ) : (
                                                        <span className="text-muted">Not Scheduled Yet</span>
                                                    )}
                                                </td>
                                                <td>{row.astrologer?.name || "-"}</td>
                                                <td>₹{row.amount}</td>
                                                <td>
                                                    <span
                                                        className="badge badge-warning"
                                                    >
                                                        {row.booking_status}
                                                    </span>
                                                </td>
                                                <td>
                                                    {row.Payment?.payment_method || "N/A"}
                                                    ({row.Payment?.payment_status || "N/A"})
                                                </td>
                                                <td className="text-center">
                                                    <button
                                                        className="btn ripple btn-main-primary signbtn"
                                                        onClick={() => openRescheduleModal(row)}
                                                    >
                                                        Reschedule
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3 d-flex justify-content-between align-items-center">
                            <b>Total Records: {datalength}</b>
                            {datalength > 0 && (
                                <CustomPagination
                                    datalength={datalength}
                                    itemperpage={itemperpage}
                                    currentPage={page}
                                    setPage={setPage}
                                    pageRoute={[
                                        { name: "Reschedule Puja", path: "/admin/puja/reschedules" },
                                    ]}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Reschedule Modal */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                size="lg"
                className="custom-modal"
                style={{ visibility: "visible", pointerEvents: "initial" }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reschedule Booking</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                            New Date
                        </Form.Label>
                        <Form.Control
                            type="date"
                            value={rescheduleDate}
                            onChange={(e) => setRescheduleDate(e.target.value)}
                            min={new Date().toISOString().split("T")[0]}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                            New Time
                        </Form.Label>
                        <Form.Control
                            type="time"
                            value={rescheduleTime}
                            onChange={(e) => setRescheduleTime(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger ripple" onClick={() => setShowModal(false)}>
                        Cancel
                    </button>
                    <button
                        className="btn ripple btn-main-primary signbtn"
                        onClick={handleReschedule}
                        disabled={actionLoader}
                    >
                        {actionLoader ? "Saving..." : "Save Reschedule"}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ReschedulePujaList;
